import { URL_REPLACEMENT } from '$const';
import { get, post } from '~services/api/methods';

export enum GrantsApiKeysEnum {
  GetNodeGrants = 'getNodeGrants',
  SetNodeGrants = 'setNodeGrants',
}

export const getNodeGrants = async (nodeId: string) => {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/contentAccess/menu_link_grants/${nodeId}`;
  const response = await get<MenuLinkGrantsDto>(requestUrl);
  // ToDo: add validation! see api/validators/*
  return response;
};

export const setNodeGrants = async ({ nodeId, grants }: { nodeId: string; grants: UpdateMenuLinkGrantsDto }) => {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/contentAccess/menu_link_grants/${nodeId}`;
  const response = await post<boolean>(requestUrl, grants);
  // ToDo: add validation! see api/validators/*
  return response;
};
